module.exports = __webpack_public_path__ + "img/iPhone_ 12Pro.f8027bd7.png";